import { useLocation, useNavigate } from 'react-router';
import styles from './Sidebar.module.css';
import { FaRegUser } from 'react-icons/fa';
import { useMemo, useState } from 'react';

import Config from '../../Config.json';

import { RxDashboard } from "react-icons/rx";
import { FaAngleDoubleLeft, FaRegChartBar, FaRegClipboard } from 'react-icons/fa';
import { LuLogOut } from 'react-icons/lu';
import { TbUserSearch } from 'react-icons/tb';
import { MdOutlinePersonSearch, MdOutlineGroup, MdOutlineSportsScore } from 'react-icons/md';
import { RiFeedbackLine } from 'react-icons/ri';
import { AiOutlineDotChart } from "react-icons/ai";
import { IoCalendarOutline } from "react-icons/io5";
import Logo from './assets/Logo.png';
import { GoStopwatch } from "react-icons/go";
import { useUser } from '../../Context/useUser';

const ICON_SIZE = '1.4em';

const iconMap = {
    Dashboard: <RxDashboard size={ICON_SIZE} />,
    Profile: <FaRegUser size={ICON_SIZE} />,
    Tests: <GoStopwatch size={ICON_SIZE} />,
    Calendar: <IoCalendarOutline size={ICON_SIZE} />,
    Performance: <FaRegChartBar size={ICON_SIZE} />,
    RaceAnalysis: <AiOutlineDotChart size={ICON_SIZE} />,
    Macrocycle: <FaRegClipboard size={ICON_SIZE} />,
    Logout: <LuLogOut size={ICON_SIZE} />,
    AthleteSearch: <TbUserSearch size={ICON_SIZE} />,
    Coach: <TbUserSearch size={ICON_SIZE} />,
    Feedback: <RiFeedbackLine size={ICON_SIZE} />,
    Group: <MdOutlineGroup size={ICON_SIZE} />,
    Program: <MdOutlineSportsScore size={ICON_SIZE} />
};

export default function Sidebar({ pages }) {
    const [isCollapsed, setIsCollapsed] = useState(
        localStorage.getItem('sideBarStatus') === 'collapsed'
    );

    const { clearSession } = useUser();

    const navigate = useNavigate();

    const { pathname } = useLocation();

    const logout = () => {
        clearSession();
        navigate('/');
    };

    const toggleCollapsed = () => {
        setIsCollapsed(isCollapsed => {
            localStorage.setItem('sideBarStatus', !isCollapsed ? 'collapsed' : 'notcollapsed');
            return !isCollapsed;
        });
    };

    const splitted = useMemo(() => pathname.split('/'), [pathname]);
    return (
        <div className={`${styles.navigation} ${isCollapsed ? styles.isCollapsed : ''} island`}>
            <div className={styles.logoWrap} onClick={() => navigate('/')}>
                <img
                    className={styles.logo}
                    src={Logo}
                    alt='logo'
                    style={{ width: isCollapsed ? '100%' : '40%' }}
                />
                {!isCollapsed && <div className={styles.logoText}>{Config.Appname}</div>}
            </div>
            <br />
            <div className={styles.navigationContent}>
                <div className={`${styles.navigationButtons}`}>
                    {pages.map((page, index) => [
                        <button
                            key={`${page.path}-${index}`}
                            onClick={() => navigate(page.path)}
                            className={`${styles.navigationButton} ${
                                splitted.includes(page.path) ? styles.active : ''
                            }`}
                        >
                            {iconMap[page.icon]}
                            {!isCollapsed && page.alias}
                        </button>,
                        page.menuBreak ? (
                            <span
                                key={index}
                                className={styles.menuBreakUnderline}
                            ></span>
                        ) : null
                    ])}
                </div>
                <div className={styles.navigationBottom}>
                    <div className={styles.burger} onClick={toggleCollapsed}>
                        <FaAngleDoubleLeft size={ICON_SIZE} />
                    </div>
                    <button
                        onClick={() => {
                            navigate('/feedback');
                        }}
                        className={`${styles.navigationButton}`}
                    >
                        {iconMap['Feedback']}
                        {!isCollapsed && 'Feedback'}
                    </button>
                    <button onClick={logout} className={`${styles.navigationButton}`}>
                        {iconMap['Logout']}
                        {!isCollapsed && 'Logout'}
                    </button>
                </div>
            </div>
        </div>
    );
}
